import { useState } from "react";
import BlueButton from "../../common/BlueButton/BlueButton";
import "./CookieInfoBar.css";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const CookieInfoBar = () => {
    const { t } = useTranslation("cookieBar");
    const [cookieBarDisplayClass, setCookieBarDisplayClass] =
        useState("DisplayCookieBar");

    let displayElement = <></>;

    if (!cookies.get("CookieInfoBarChecked")) {
        displayElement = (
            <>
                <div className={cookieBarDisplayClass}>
                    <p className="DisplayCookieBarText">
                        {t("websiteUsesCookies")}
                    </p>
                    <div className="DisplayCookieBarButtonContainer">
                        <BlueButton
                            text={t("gotIt")}
                            onClick={() => {
                                document.cookie =
                                    "CookieInfoBarChecked=" +
                                    true +
                                    ";expires=" +
                                    new Date(
                                        new Date().getTime() +
                                            60 * 60 * 500000 * 24,
                                    ).toGMTString() +
                                    ";path=/";
                                setCookieBarDisplayClass(
                                    "DisplayCookieBarHidden",
                                );
                            }}
                        />
                    </div>
                </div>
            </>
        );
    }

    return <> {displayElement} </>;
};

export default CookieInfoBar;
